import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=a8717aa0&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
import style0 from "../../components/Formulario/formularioNuevo.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./Contact.vue?vue&type=style&index=1&id=a8717aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8717aa0",
  null
  
)

export default component.exports